import React from "react";
import { useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormSelectBox from "../FormSelectBox";

function ReservationChildrenFields({
  onAgesChange,
  className = "mb-4",
  agesClassName,
  afterCount,
}) {
  const { values, setFieldValue } = useFormikContext();
  const { t } = useTranslation("reservations");
  const ages = values.reservation_child_ages;
  const ageOptions = Array.from({ length: 18 }, (_, age) => ({
    value: age,
    name: t("editBookingDetails.kidsAge", { count: age }),
  }));

  function setAges(nextAges) {
    setFieldValue("reservation_child_ages", nextAges);
    onAgesChange?.(nextAges);
  }

  function changeChildCount(event) {
    setAges(
      Array.from(
        { length: Number(event.target.value) },
        (_, index) => ages[index] ?? ""
      )
    );
  }

  function changeChildAge(index, event) {
    const nextAges = [...ages];
    nextAges[index] =
      event.target.value === "" ? "" : Number(event.target.value);
    setAges(nextAges);
  }

  return (
    <div className={className}>
      <Form.Group>
        <Form.Label>{t("editBookingDetails.amountKids")}</Form.Label>
        <Form.Control
          as="select"
          value={ages.length}
          onChange={changeChildCount}
        >
          {Array.from({ length: Math.max(5, ages.length + 2) }, (_, count) => (
            <option key={count} value={count}>
              {t("common:online_reservation.amountKids", { count })}
            </option>
          ))}
        </Form.Control>
      </Form.Group>
      {afterCount}
      {ages.length > 0 && (
        <div className={agesClassName}>
          {ages.map((age, index) => (
            <FormSelectBox
              key={index}
              name={`reservation_child_ages[${index}]`}
              label={t("editBookingDetails.childAge", { number: index + 1 })}
              value={age}
              options={ageOptions}
              required
              onChange={(event) => changeChildAge(index, event)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default ReservationChildrenFields;
